// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";

function PilotContent(props) {
  return React.createElement("div", {
              className: "PilotContent text-lg pl-5 leading-10"
            }, props.children);
}

var make = PilotContent;

export {
  make ,
}
/* react Not a pure module */
